module.exports = function(successCallback, errorCallback) {
	require.ensure([], function() {
		successCallback(require("!!../../node_modules/babel-loader/lib/index.js!./OnlineScrapBook.js"));
	}, function() {
		if (errorCallback) errorCallback.apply(this, arguments);
	});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/split-chunk-loader?lazy!./src/StaticPage/OnlineScrapBook.js
// module id = 1281
// module chunks = 58